// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter {
    margin-bottom: 15px;
}

.user-consents-filter-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 16px;
}

.user-consents-filter-field {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.user-consents-filter-field--uid {
    flex-wrap: wrap;
}

.user-consents-filter-label {
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #9a9a9a;
    font-weight: 600;
}

.user-consents-filter-select {
    background: rgba(0, 0, 0, 0.25);
    color: #e8e8e8;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 0.85rem;
    cursor: pointer;
    min-width: 160px;
}

.user-consents-filter-input {
    background: rgba(0, 0, 0, 0.25);
    color: #e8e8e8;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 0.85rem;
    min-width: 180px;
}

.user-consents-filter-input:focus-visible {
    outline: 2px solid var(--intastellarGold, #d9b255);
    outline-offset: 2px;
}

.user-consents-filter-apply {
    border: 1px solid rgba(192, 159, 83, 0.4);
    background: rgba(192, 159, 83, 0.16);
    color: #f5e6c5;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
}

.user-consents-filter-apply:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.user-consents-filter-apply:hover:not(:disabled) {
    background: rgba(192, 159, 83, 0.24);
}

.user-consents-filter-select:focus-visible {
    outline: 2px solid var(--intastellarGold, #d9b255);
    outline-offset: 2px;
}

.user-consents-filter-note {
    font-size: 0.8rem;
    color: #a5a5a5;
}

.user-consents-filter-note--error {
    color: #ffaeae;
}

.user-consents-filter-reset {
    background: none;
    border: none;
    padding: 0;
    color: var(--intastellarGold, #d9b255);
    cursor: pointer;
    font: inherit;
    text-decoration: underline;
}

.user-consents-filter-reset:hover {
    text-decoration: none;
}

.user-consents-filter-chip {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 4px 6px 4px 10px;
    background: rgba(192, 159, 83, 0.12);
    border: 1px solid rgba(192, 159, 83, 0.45);
    border-radius: 999px;
    font-size: 0.78rem;
    color: #f5e6c5;
    line-height: 1;
}

.user-consents-filter-chip__label {
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-size: 0.66rem;
    color: rgba(245, 230, 197, 0.7);
    font-weight: 600;
}

.user-consents-filter-chip__value {
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.04em;
}

.user-consents-filter-chip__clear {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    color: #f5e6c5;
    font-size: 0.9rem;
    line-height: 1;
    cursor: pointer;
    transition: background 0.12s ease, color 0.12s ease;
}

.user-consents-filter-chip__clear:hover,
.user-consents-filter-chip__clear:focus-visible {
    background: rgba(192, 159, 83, 0.4);
    color: #fff;
    outline: none;
}

.user-consents-empty-filter {
    padding: 12px 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.08);
    color: #c5c5c5;
    font-size: 0.9rem;
}

.regulation {
    color: var(--intastellarGold);
    font-weight: bold;
    text-transform: uppercase;
}

.user-consent-card__transfer-primary {
    display: block;
    font-weight: 600;
    overflow-wrap: anywhere;
}

.user-consent-card__transfer-secondary {
    display: block;
    margin-top: 2px;
    font-size: 0.78rem;
    color: #9a9a9a;
    line-height: 1.35;
    overflow-wrap: anywhere;
    hyphens: auto;
}

.lb {
    font-size: 14px;
    color: #666;
    font-style: italic;
}

.link {
    color: var(--intastellarGold);
    text-decoration: none;
    font-weight: bold;
}

/* Consent overview cards */
.user-consents-load-more {
    display: flex;
    justify-content: center;
    padding: 24px 16px 40px;
}

.user-consents-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 340px), 1fr));
    gap: 20px;
    align-items: stretch;
}

.user-consent-card {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 0;
    border-radius: 10px;
    overflow: hidden;
    background: radial-gradient(circle at top, rgb(101, 101, 101) -10%, rgb(48, 48, 48));
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.22), inset -1px 1px 1px rgba(255, 255, 255, 0.08);
    color: rgb(197, 197, 197);
    text-align: left;
}

.user-consent-card__header {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    background: rgba(0, 0, 0, 0.2);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.user-consent-card__header-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
    min-width: 0;
    flex: 1;
}

.user-consent-card__id-line {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 8px;
    justify-content: flex-end;
    max-width: 100%;
}

.user-consent-card__id-label {
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #888;
    flex-shrink: 0;
}

.user-consent-card__id-value {
    font-size: 0.8rem;
    color: #a0a0a0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: min(100%, 260px);
    text-align: right;
}

.user-consent-card__badge {
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #c8c8c8;
    padding: 4px 10px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.08);
}

.user-consent-card__meta {
    margin: 0;
    padding: 12px 16px;
    display: grid;
    gap: 8px;
}

.user-consent-card__row {
    display: grid;
    grid-template-columns: 150px 1fr;
    gap: 12px;
    align-items: baseline;
    font-size: 0.9rem;
}

.user-consent-card__row dt {
    margin: 0;
    color: #9a9a9a;
    font-weight: 500;
}

.user-consent-card__row dd {
    margin: 0;
    color: #d8d8d8;
    text-align: right;
    min-width: 0;
    overflow-wrap: anywhere;
}

.user-consent-card__urls {
    padding: 0 16px 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.user-consent-card__url-block {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.user-consent-card__url-label {
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #888;
}

.user-consent-card__url-text {
    font-size: 0.8rem;
    line-height: 1.4;
    word-break: break-all;
    color: #b5b5b5;
}

.user-consent-card__choices {
    padding: 12px 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.12);
}

.user-consent-card__choices-title {
    margin: 0 0 10px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #a8a8a8;
}

.user-consent-card__choice-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.user-consent-card__choice-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.user-consent-card__choice-name {
    font-size: 0.9rem;
    color: #d0d0d0;
}

.user-consent-card__choice-name::after {
    content: " cookies";
    color: #888;
    font-size: 0.85em;
}

.user-consent-card__pill {
    font-size: 0.75rem;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 999px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    flex-shrink: 0;
}

.user-consent-card__pill--accepted {
    background: rgba(76, 175, 80, 0.25);
    color: #a5e9a8;
    border: 1px solid rgba(76, 175, 80, 0.35);
}

.user-consent-card__pill--declined {
    background: rgba(170, 170, 170, 0.2);
    color: #e2e2e2;
    border: 1px solid rgba(171, 171, 171, 0.3);
}

.user-consent-card__pill--mixed {
    background: rgba(255, 193, 7, 0.15);
    color: #ffe082;
    border: 1px solid rgba(255, 193, 7, 0.25);
}

.user-consent-card__footer {
    margin-top: auto;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    font-size: 0.85rem;
}

.user-consent-card__version-label {
    color: #888;
    text-transform: uppercase;
    font-size: 0.7rem;
    letter-spacing: 0.05em;
}

.user-consent-card__version-link {
    color: var(--intastellarGold);
    font-weight: 600;
    text-decoration: none;
}

.user-consent-card__version-link:hover {
    text-decoration: underline;
}

.user-consent-card__footer-version {
    display: inline-flex;
    align-items: baseline;
    gap: 8px;
    margin-left: auto;
}

.user-consent-card__prior {
    display: inline-flex;
    align-items: baseline;
    gap: 8px;
    min-width: 0;
    max-width: 60%;
}

.user-consent-card__prior-id {
    font-size: 0.8rem;
    color: #b5b5b5;
    font-family: "SFMono-Regular", Menlo, Consolas, monospace;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

@media screen and (max-width: 480px) {
    .user-consent-card__row {
        grid-template-columns: 1fr;
        gap: 2px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/UserConsents/Style.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,cAAc;IACd,2CAA2C;IAC3C,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,cAAc;IACd,2CAA2C;IAC3C,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;IACzC,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,sCAAsC;IACtC,eAAe;IACf,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,oCAAoC;IACpC,0CAA0C;IAC1C,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,mDAAmD;AACvD;;AAEA;;IAEI,mCAAmC;IACnC,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,2CAA2C;IAC3C,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uEAAuE;IACvE,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,oFAAoF;IACpF,uFAAuF;IACvF,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,8BAA8B;IAC9B,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;IACR,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,QAAQ;IACR,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,+CAA+C;IAC/C,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,QAAQ;IACR,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yDAAyD;IACzD,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;QAC1B,QAAQ;IACZ;AACJ","sourcesContent":[".filter {\n    margin-bottom: 15px;\n}\n\n.user-consents-filter-bar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 12px 16px;\n}\n\n.user-consents-filter-field {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.user-consents-filter-field--uid {\n    flex-wrap: wrap;\n}\n\n.user-consents-filter-label {\n    font-size: 0.72rem;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: #9a9a9a;\n    font-weight: 600;\n}\n\n.user-consents-filter-select {\n    background: rgba(0, 0, 0, 0.25);\n    color: #e8e8e8;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 6px;\n    padding: 6px 10px;\n    font-size: 0.85rem;\n    cursor: pointer;\n    min-width: 160px;\n}\n\n.user-consents-filter-input {\n    background: rgba(0, 0, 0, 0.25);\n    color: #e8e8e8;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 6px;\n    padding: 6px 10px;\n    font-size: 0.85rem;\n    min-width: 180px;\n}\n\n.user-consents-filter-input:focus-visible {\n    outline: 2px solid var(--intastellarGold, #d9b255);\n    outline-offset: 2px;\n}\n\n.user-consents-filter-apply {\n    border: 1px solid rgba(192, 159, 83, 0.4);\n    background: rgba(192, 159, 83, 0.16);\n    color: #f5e6c5;\n    border-radius: 6px;\n    padding: 6px 10px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.user-consents-filter-apply:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.user-consents-filter-apply:hover:not(:disabled) {\n    background: rgba(192, 159, 83, 0.24);\n}\n\n.user-consents-filter-select:focus-visible {\n    outline: 2px solid var(--intastellarGold, #d9b255);\n    outline-offset: 2px;\n}\n\n.user-consents-filter-note {\n    font-size: 0.8rem;\n    color: #a5a5a5;\n}\n\n.user-consents-filter-note--error {\n    color: #ffaeae;\n}\n\n.user-consents-filter-reset {\n    background: none;\n    border: none;\n    padding: 0;\n    color: var(--intastellarGold, #d9b255);\n    cursor: pointer;\n    font: inherit;\n    text-decoration: underline;\n}\n\n.user-consents-filter-reset:hover {\n    text-decoration: none;\n}\n\n.user-consents-filter-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 4px 6px 4px 10px;\n    background: rgba(192, 159, 83, 0.12);\n    border: 1px solid rgba(192, 159, 83, 0.45);\n    border-radius: 999px;\n    font-size: 0.78rem;\n    color: #f5e6c5;\n    line-height: 1;\n}\n\n.user-consents-filter-chip__label {\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    font-size: 0.66rem;\n    color: rgba(245, 230, 197, 0.7);\n    font-weight: 600;\n}\n\n.user-consents-filter-chip__value {\n    font-weight: 700;\n    color: #fff;\n    letter-spacing: 0.04em;\n}\n\n.user-consents-filter-chip__clear {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    padding: 0;\n    border: none;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.08);\n    color: #f5e6c5;\n    font-size: 0.9rem;\n    line-height: 1;\n    cursor: pointer;\n    transition: background 0.12s ease, color 0.12s ease;\n}\n\n.user-consents-filter-chip__clear:hover,\n.user-consents-filter-chip__clear:focus-visible {\n    background: rgba(192, 159, 83, 0.4);\n    color: #fff;\n    outline: none;\n}\n\n.user-consents-empty-filter {\n    padding: 12px 16px;\n    margin-bottom: 16px;\n    border-radius: 8px;\n    background: rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    color: #c5c5c5;\n    font-size: 0.9rem;\n}\n\n.regulation {\n    color: var(--intastellarGold);\n    font-weight: bold;\n    text-transform: uppercase;\n}\n\n.user-consent-card__transfer-primary {\n    display: block;\n    font-weight: 600;\n    overflow-wrap: anywhere;\n}\n\n.user-consent-card__transfer-secondary {\n    display: block;\n    margin-top: 2px;\n    font-size: 0.78rem;\n    color: #9a9a9a;\n    line-height: 1.35;\n    overflow-wrap: anywhere;\n    hyphens: auto;\n}\n\n.lb {\n    font-size: 14px;\n    color: #666;\n    font-style: italic;\n}\n\n.link {\n    color: var(--intastellarGold);\n    text-decoration: none;\n    font-weight: bold;\n}\n\n/* Consent overview cards */\n.user-consents-load-more {\n    display: flex;\n    justify-content: center;\n    padding: 24px 16px 40px;\n}\n\n.user-consents-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(min(100%, 340px), 1fr));\n    gap: 20px;\n    align-items: stretch;\n}\n\n.user-consent-card {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    padding: 0;\n    border-radius: 10px;\n    overflow: hidden;\n    background: radial-gradient(circle at top, rgb(101, 101, 101) -10%, rgb(48, 48, 48));\n    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.22), inset -1px 1px 1px rgba(255, 255, 255, 0.08);\n    color: rgb(197, 197, 197);\n    text-align: left;\n}\n\n.user-consent-card__header {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 14px 16px;\n    background: rgba(0, 0, 0, 0.2);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.user-consent-card__header-meta {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 6px;\n    min-width: 0;\n    flex: 1;\n}\n\n.user-consent-card__id-line {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 8px;\n    justify-content: flex-end;\n    max-width: 100%;\n}\n\n.user-consent-card__id-label {\n    font-size: 0.68rem;\n    font-weight: 600;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: #888;\n    flex-shrink: 0;\n}\n\n.user-consent-card__id-value {\n    font-size: 0.8rem;\n    color: #a0a0a0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: min(100%, 260px);\n    text-align: right;\n}\n\n.user-consent-card__badge {\n    font-size: 0.75rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #c8c8c8;\n    padding: 4px 10px;\n    border-radius: 6px;\n    background: rgba(255, 255, 255, 0.08);\n}\n\n.user-consent-card__meta {\n    margin: 0;\n    padding: 12px 16px;\n    display: grid;\n    gap: 8px;\n}\n\n.user-consent-card__row {\n    display: grid;\n    grid-template-columns: 150px 1fr;\n    gap: 12px;\n    align-items: baseline;\n    font-size: 0.9rem;\n}\n\n.user-consent-card__row dt {\n    margin: 0;\n    color: #9a9a9a;\n    font-weight: 500;\n}\n\n.user-consent-card__row dd {\n    margin: 0;\n    color: #d8d8d8;\n    text-align: right;\n    min-width: 0;\n    overflow-wrap: anywhere;\n}\n\n.user-consent-card__urls {\n    padding: 0 16px 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.user-consent-card__url-block {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.user-consent-card__url-label {\n    font-size: 0.7rem;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: #888;\n}\n\n.user-consent-card__url-text {\n    font-size: 0.8rem;\n    line-height: 1.4;\n    word-break: break-all;\n    color: #b5b5b5;\n}\n\n.user-consent-card__choices {\n    padding: 12px 16px;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n    background: rgba(0, 0, 0, 0.12);\n}\n\n.user-consent-card__choices-title {\n    margin: 0 0 10px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: #a8a8a8;\n}\n\n.user-consent-card__choice-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.user-consent-card__choice-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.user-consent-card__choice-name {\n    font-size: 0.9rem;\n    color: #d0d0d0;\n}\n\n.user-consent-card__choice-name::after {\n    content: \" cookies\";\n    color: #888;\n    font-size: 0.85em;\n}\n\n.user-consent-card__pill {\n    font-size: 0.75rem;\n    font-weight: 600;\n    padding: 4px 10px;\n    border-radius: 999px;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    flex-shrink: 0;\n}\n\n.user-consent-card__pill--accepted {\n    background: rgba(76, 175, 80, 0.25);\n    color: #a5e9a8;\n    border: 1px solid rgba(76, 175, 80, 0.35);\n}\n\n.user-consent-card__pill--declined {\n    background: rgba(170, 170, 170, 0.2);\n    color: #e2e2e2;\n    border: 1px solid rgba(171, 171, 171, 0.3);\n}\n\n.user-consent-card__pill--mixed {\n    background: rgba(255, 193, 7, 0.15);\n    color: #ffe082;\n    border: 1px solid rgba(255, 193, 7, 0.25);\n}\n\n.user-consent-card__footer {\n    margin-top: auto;\n    padding: 12px 16px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n    font-size: 0.85rem;\n}\n\n.user-consent-card__version-label {\n    color: #888;\n    text-transform: uppercase;\n    font-size: 0.7rem;\n    letter-spacing: 0.05em;\n}\n\n.user-consent-card__version-link {\n    color: var(--intastellarGold);\n    font-weight: 600;\n    text-decoration: none;\n}\n\n.user-consent-card__version-link:hover {\n    text-decoration: underline;\n}\n\n.user-consent-card__footer-version {\n    display: inline-flex;\n    align-items: baseline;\n    gap: 8px;\n    margin-left: auto;\n}\n\n.user-consent-card__prior {\n    display: inline-flex;\n    align-items: baseline;\n    gap: 8px;\n    min-width: 0;\n    max-width: 60%;\n}\n\n.user-consent-card__prior-id {\n    font-size: 0.8rem;\n    color: #b5b5b5;\n    font-family: \"SFMono-Regular\", Menlo, Consolas, monospace;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n@media screen and (max-width: 480px) {\n    .user-consent-card__row {\n        grid-template-columns: 1fr;\n        gap: 2px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
